import { render, staticRenderFns } from "./SyntheseIndex.vue?vue&type=template&id=13b608c4&"
import script from "./SyntheseIndex.vue?vue&type=script&lang=js&"
export * from "./SyntheseIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b608c4')) {
      api.createRecord('13b608c4', component.options)
    } else {
      api.reload('13b608c4', component.options)
    }
    module.hot.accept("./SyntheseIndex.vue?vue&type=template&id=13b608c4&", function () {
      api.rerender('13b608c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vente-creance/synthese/SyntheseIndex.vue"
export default component.exports